import useDataset from "datasets/hooks/useDataset";
import yn from "yn";
import useUserPermission from "~/hooks/useUserPermission";

const { VITE_DATASET_PERMISSIONS_ENABLED } = import.meta.env;

/**
 * Hook that returns `true` if the current user has the required dataset permission.
 * When `VITE_DATASET_PERMISSIONS_ENABLED` is set, checks only the Catalog API's
 * `actions_permitted` on the dataset (all actions are defined in `DatasetActions` in
 * schema.py and fully covered by the backend for owner-level access).
 * Falls back to the Auth0 scope check alone when the flag is off.
 *
 * @param permission a single dataset action (e.g. "create:catalog-report")
 * @returns
 */
const usePermissions = (permission: string): boolean => {
  const { data: dataset } = useDataset();
  const hasPermission = useUserPermission(permission);

  if (yn(VITE_DATASET_PERMISSIONS_ENABLED)) {
    return !!dataset?.actions_permitted.includes(permission);
  }

  return hasPermission;
};

export default usePermissions;
